export default __webpack_public_path__ + "static/media/flappy_viz_title.75f92f11.png";